import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { visitorMessages } from 'src/features/visitor/utils/messages';
import { useSidePanel } from 'src/registry/providers/SidePanelProvider';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { ICON_MAP } from 'src/utils/constants';

interface CellVisitorStaysTableActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    singleRowSelection: (rowId: string) => void;
    sidePanelName: string;
}

function CellSidePanelActions<TData, TValue>({
    sidePanelName,
    singleRowSelection,
    row,
}: CellVisitorStaysTableActionsProps<TData, TValue>) {
    const { formatMessage } = useIntl();
    const { openPanel } = useSidePanel();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        singleRowSelection(row.id.toString());
        openPanel(sidePanelName);
    };

    return (
        <div className="ml-auto flex max-w-24 gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button onClick={handleClick} size="icon" variant="link">
                            <FontAwesomeIcon icon={ICON_MAP.SIDE_PANEL} className="cursor-pointer" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="top">{formatMessage(visitorMessages.sidePanel)}</TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}

export { CellSidePanelActions };
